export default __webpack_public_path__ + "static/media/Wedding7.d8f84b44.jpg";